import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SystemConfigForm from './forms/SystemConfigForm';
import AlarmConfigForm from './forms/AlarmConfigForm';
import ReportConfigForm from './forms/ReportConfigForm';
import UserManagementForm from './forms/UserManagementForm';
import MessageQueStatus from './forms/MessageQueForm';
import ShareScreen from './forms/ShareScreen';
import SelfTest from './forms/SelfTest';
import VideoPlayer from './forms/VideoPlayer';
import SystemRestart from './forms/SystemRestart';
import SystemCalibration from './forms/SystemCalibration';
import RestoreUpdates from './forms/RestoreandUpdates';
import LogSearch from './forms/LogSearch';

const ContentCard = ({ content }) => {
  if (!content) {
    return (
      <div className="bg-gray-100 rounded-lg h-full w-full flex items-center justify-center sticky top-4 mx-auto">
        <p className="text-gray-500 text-sm">Select a component to view details</p>
      </div>
    );
  }
  const Icon = content.icon;
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={content.id}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        className="bg-gray-100 p-4 md:p-6 rounded-lg h-full sticky top-4 w-full mx-auto" // Full width on mobile, centered on larger screens
      >
        <div className="flex items-center gap-4 mb-4">
          <div className="text-blue-800 w-10 h-10 md:w-12 md:h-12">
            <Icon className="w-full h-full" />
          </div>
          <h2 className="text-lg md:text-xl font-semibold text-blue-800">{content.title}</h2>
        </div>
        
        <div className="overflow-y-auto pr-2 h-[calc(100%-5rem)] custom-scrollbar">
          {content.id === 'system-config' ? (
            <SystemConfigForm />
          ) : content.id === 'alarm-config' ? (
            <AlarmConfigForm />
          ) : content.id === 'report-config' ? (
            <ReportConfigForm />
          ) : content.id === 'user-management' ? (
            <UserManagementForm />
          ) : content.id === 'message-status' ? (
            <MessageQueStatus />
          ) : content.id === 'share-screen' ? (
            <ShareScreen />
          ) : content.id === 'self-test' ? (
            <SelfTest />
          ): content.id === 'video-player' ? (
            <VideoPlayer />
          ): content.id === 'system-restart' ? (
            <SystemRestart />
          ): content.id === 'system-calibration' ? (
            <SystemCalibration />
          ): content.id === 'restore-update' ? (
            <RestoreUpdates />
          ): content.id === 'log-search' ? (
            <LogSearch />
          ): (
            <p className="text-sm text-gray-600">{content.description}</p>
          )}
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default ContentCard;